import React, { useState, FormEvent } from 'react'
import Template from './components/template'
import auth from './lib/auth'
import { user } from './lib/api'

export default function AccountPage() {
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [loading, setLoading] = useState(false)

    async function editUser(e: FormEvent) {
        e.preventDefault()
        if (auth.user?.sub && newPassword === confirmPassword) {
            setLoading(true)
            await user.update(auth.user.sub, { password: newPassword })
            setLoading(false)
        }
    }

    return (
        <Template>
            <div className='container mx-auto mt-5'>
                <h1>Account</h1>
                <h3>Change Password</h3>
                <form onSubmit={editUser}>
                    <div className='font-bold text-gray-500'>New Password</div>
                    <input
                        type='password'
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <div className='font-bold text-gray-500'>Re-enter New Password</div>
                    <input
                        type='password'
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <div className='my-2'>
                        <button
                            className='blue'
                            disabled={loading || !newPassword || newPassword !== confirmPassword}
                        >
                            Change Password
                        </button>
                    </div>
                </form>
            </div>
        </Template>
    )
}
